import http from "../helpers/http";

export const createInvoice = async (payload) => {
  const response = await http().post("/PaymentInvoice/Create", payload);
  return response.data;
};

export const fetchInvoiceData = async (code) => {
  const response = await http().get(
    `/PaymentInvoice/GetPaymentInvoiceInformation/${code}`
  );
  return response.data;
};

export const fetchAllInvoice = async () => {
  const response = await http().get("/PaymentInvoice/List");
  return response.data;
};
